import { List } from 'immutable';
import memoize from 'transmute/memoize';
import { PartialStates } from 'automation-ui-log-events/constants/LogEventStateConstants';
import LogEventKeys from 'automation-ui-log-events/constants/LogEventKeys';
import { getLogEventMessages } from 'automation-ui-log-events/configs/LogEventMessageConfigs';
import { getMostSpecificPathFromKeys } from 'automation-ui-log-events/utils/messagePathUtils';
import { getLogEventMessageOptions } from 'automation-ui-log-events/utils/messageOptionUtils';
import { ExecutionStates, NotificationTypes } from 'automation-ui-log-events/constants/LogEventConstants';
import { getIdempotencyId, getNotificationType, getState, getType, getActionType } from 'automation-ui-log-events/records/LogEvent/utils';
import { getIsClassicTest } from 'automation-ui-log-events/records/LogEvent/contextMapUtils';
export const getStatusCategory = logEvent => {
  const state = getState(logEvent);
  if (state && PartialStates.includes(state)) {
    return 'warning';
  }
  const notificationType = getNotificationType(logEvent);
  switch (notificationType) {
    case NotificationTypes.ERROR:
      return 'error';
    case NotificationTypes.INFORMATION:
      return 'info';
    default:
      return 'success';
  }
};
export const getStatusKey = statusCategory => `${LogEventKeys.ROOT_KEY}.status.${statusCategory}`;
export const isEnrolledTestObject = logEvent => !!getIsClassicTest(logEvent);
export const getPartialSuccessMessagePath = (executionResult, logEvent) => {
  const logEventType = getType(logEvent);
  const actionType = getActionType(logEvent);
  const errorType = executionResult.getErrorType();
  const errorSubType = executionResult.getErrorSubType();
  const keys = List([logEventType, ExecutionStates.FAIL_CONTINUE, actionType, errorType, errorSubType]);
  return getMostSpecificPathFromKeys(keys);
};
export const getLogEventDetail = memoize((logEvent, objectTypeId) => {
  const statusCategory = getStatusCategory(logEvent);
  const messages = getLogEventMessages(logEvent, objectTypeId);
  const messageOptions = getLogEventMessageOptions(logEvent, objectTypeId);
  const isTestObject = isEnrolledTestObject(logEvent);
  return {
    messages,
    messageOptions,
    isTestObject,
    statusCategory,
    statusKey: getStatusKey(statusCategory)
  };
}, logEvent => getIdempotencyId(logEvent));